// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { NewContextMenuItemType } from '@shared/utils/ContextMenuUtils';
import { PenStyle } from '../Graphics';
import { Resources } from '@shared/localizations/Resources';
export class LineStyleUtils {
    static getCBItems() {
        const items = [];
        const configs = [
            {
                type: NewContextMenuItemType.Image,
                key: 'chart.tool.line',
                value: PenStyle.SimpleChart,
                svgImage: 'LWS-line'
            },
            {
                type: NewContextMenuItemType.Image,
                key: 'chart.tool.dot',
                value: PenStyle.DotChart,
                svgImage: 'LWS-dot'
            },
            {
                type: NewContextMenuItemType.Image,
                key: 'chart.tool.dotline',
                value: PenStyle.DotLineChart,
                svgImage: 'LWS-dotted'
            },
            {
                type: NewContextMenuItemType.Image,
                key: 'chart.tool.IsoDot',
                value: PenStyle.IsoDotChart,
                svgImage: 'LWS-isoDot'
            },
            {
                type: NewContextMenuItemType.Image,
                key: 'chart.tool.ShapedLine',
                value: PenStyle.ShapedChart,
                svgImage: 'LWS-shapedLine'
            },
            {
                type: NewContextMenuItemType.Image,
                key: 'chart.tool.DottedLine',
                value: PenStyle.ShapedDotChart,
                svgImage: 'LWS-looselyDottedLine'
            },
            {
                type: NewContextMenuItemType.Image,
                key: 'chart.tool.Dash',
                value: PenStyle.ShapedDoubleDotChart,
                svgImage: 'LWS-dash'
            }
        ];
        for (const cfg of configs) {
            if (!Resources.isHidden(cfg.key)) {
                items.push({
                    type: NewContextMenuItemType.Image,
                    text: cfg.key,
                    value: cfg.value,
                    svgImage: cfg.svgImage
                });
            }
        }
        return items;
    }
    static createWidthItems() {
        return Array.from({ length: 10 }, (_, i) => {
            const value = i + 1;
            return {
                type: NewContextMenuItemType.Image,
                svgImage: `LWS-${value}px`,
                value
            };
        });
    }
}
